import { RouteObject } from "react-router-dom";
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect";
import { AllowedDomainGuard } from "@quest_editor/layout/AllowedDomainGuard";
import WithApplicationTitle from "@quest_editor/layout/WithApplicationTitle";
import PromotionList from "@quest_editor/pages/PromotionList";
import PromotionRegister from "@quest_editor/pages/PromotionRegister";
import PromotionDetail from "@quest_editor/pages/PromotionDetail";
import PromotionEdit from "@quest_editor/pages/PromotionEdit";
import PromotionDuplication from "@quest_editor/pages/PromotionDuplication";
import PromotionAnalytics from "@quest_editor/pages/PromotionAnalytics";
import QuestRegister from "@quest_editor/pages/QuestRegister";
import QuestDetail from "@quest_editor/pages/QuestDetail";
import QuestEdit from "@quest_editor/pages/QuestEdit";
import QuestEditTarget from "@quest_editor/pages/QuestEditTarget";
import QuestExtract from "@quest_editor/pages/QuestExtract";
import QuestEditLink from "@quest_editor/pages/QuestEditLink";
import QuestEditPurchase from "@quest_editor/pages/QuestEditPurchase";
import QuestEditSurvey from "@quest_editor/pages/QuestEditSurvey";
import QuestPreview from "@quest_editor/pages/QuestPreview";
import PromotionProgress from "@quest_editor/pages/PromotionProgress";
import QuestDuplication from "@quest_editor/pages/QuestDuplication";
import QuestStartRequest from "@quest_editor/pages/QuestStartRequest";
import QuestStartReview from "@quest_editor/pages/QuestStartReview";
import QuestEstimate from "@quest_editor/pages/QuestEstimate";
import QuestOrderReview from "@quest_editor/pages/QuestOrderReview";
import QuestProgressList from "@quest_editor/pages/QuestProgressList";
import AuditLog from "@quest_editor/pages/AuditLog";
import SurveyEditQuestion from "@quest_editor/pages/SurveyEditQuestion";
import SurveyPreview from "@quest_editor/pages/SurveyPreview";
import QuestAnalytics from "@quest_editor/pages/QuestAnalytics";

const QuestEditorRoutes: RouteObject[] = [
  {
    path: "quest_editor/promotion/progress/:hash",
    element: <PromotionProgress />,
  },
  {
    path: "quest_editor/quest/preview/:hash",
    element: <QuestPreview />,
  },
  {
    path: "quest_editor",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <AllowedDomainGuard />
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { index: true, element: <PromotionList /> },
      {
        element: <WithApplicationTitle />,
        children: [
          { path: "audit_log", element: <AuditLog /> },

          { path: "promotion/register", element: <PromotionRegister /> },
          { path: "promotion/:id/edit", element: <PromotionEdit /> },
          {
            path: "promotion/:id/quest/register",
            element: <QuestRegister />,
          },
          {
            path: "promotion/:id/duplication",
            element: <PromotionDuplication />,
          },
          {
            path: "promotion/:id/analytics",
            element: <PromotionAnalytics />,
          },
          { path: "promotion/:id", element: <PromotionDetail /> },

          { path: "quest/progress", element: <QuestProgressList /> },
          { path: "quest/:id/edit/target", element: <QuestEditTarget /> },
          { path: "quest/:id/edit/link", element: <QuestEditLink /> },
          {
            path: "quest/:id/edit/purchase",
            element: <QuestEditPurchase />,
          },
          { path: "quest/:id/edit/survey", element: <QuestEditSurvey /> },
          { path: "quest/:id/edit", element: <QuestEdit /> },
          { path: "quest/:id/extract", element: <QuestExtract /> },
          { path: "quest/:id/duplication", element: <QuestDuplication /> },
          {
            path: "quest/:id/start/request",
            element: <QuestStartRequest />,
          },
          {
            path: "quest/:id/start/review",
            element: <QuestStartReview />,
          },
          { path: "quest/:id/estimate", element: <QuestEstimate /> },
          { path: "quest/:id/order_review", element: <QuestOrderReview /> },
          { path: "quest/:id/analytics", element: <QuestAnalytics /> },
          { path: "quest/:id", element: <QuestDetail /> },

          { path: "survey/:id/question", element: <SurveyEditQuestion /> },
          { path: "survey/:id/preview", element: <SurveyPreview /> },
        ],
      },
    ],
  },
];

export default QuestEditorRoutes;
